<template>
    <p v-if="disclaimer" class="text-gray-600 text-[10px] italic text-justify" v-html="$translate(disclaimer)" />
</template>

<script setup>
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
const store = useStore();
const disclaimerNameIdentifier = 'analysedisclaimer';

const disclaimer = ref(null);

onMounted(async () => {
    if (disclaimer.value) {
        return;
    }

    await store.dispatch('contentpages/index').catch(() => null);

    // Fetch disclaimer content.
    // If more than one hase been found, take the newest one.
    let disclaimerData = store.getters['contentpages/getByName'](disclaimerNameIdentifier) || null;
    if (Array.isArray(disclaimerData) && disclaimerData.length > 0) {
        disclaimerData = disclaimerData.filter((item) => item?.updated_at).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0];
    } else if (typeof disclaimerData !== 'object' || disclaimerData === null) {
        disclaimerData = null;
    }

    let response = null;
    if (disclaimerData && disclaimerData?.id) {
        response = await store.dispatch('contentpages/show', disclaimerData.id).catch(() => null);
    }

    // Assign the response content or fallback disclaimer
    disclaimer.value = await response?.data?.content;
});
</script>
